"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCollectionSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getCollectionSerializer() {
    return (0, serializers_1.struct)([
        ['verified', (0, serializers_1.bool)()],
        ['key', (0, serializers_1.publicKey)()],
    ], { description: 'Collection' });
}
exports.getCollectionSerializer = getCollectionSerializer;
//# sourceMappingURL=collection.js.map